import React from "react";
import _ from "lodash";

import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import NotesInformation from "components/common/NotesInformation";
import NotesEditor from "components/common/NotesEditor";

import { MESSAGE } from "constants/Message";
import { buttonModalConfirmClass } from "helpers/StyleClass.js";
import { CUSTOM_TYPE } from "../custom-upr/Constants";

class PreviewValidateModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: JSON.stringify(props.currentData, null, 4),
      configData: _.cloneDeep(props.currentData),

      notesInput: null,

      msg: [],
      isValidated: false,
      isProcessing: false,

      isConfigDiff: !_.isEqual(props.currentData, props.originalRules),
    };

    this.handleValidate = this.handleValidate.bind(this);
    this.handleSaveData = this.handleSaveData.bind(this);
    this.handleNotesChanged = this.handleNotesChanged.bind(this);
  }

  handleNotesChanged(input) {
    this.setState({ notesInput: input });
  }

  async handleValidate() {
    const { handleValidate } = this.props;
    const { configData } = this.state;

    if (_.isNil(handleValidate)) return;

    try {
      this.setState({ isProcessing: true, msg: [] });

      const { isValid, reason } = await handleValidate(configData);

      if (isValid) {
        this.setState({
          msg: ["Validation successful!", ""],
          isValidated: true,
        });
      } else {
        this.setState({
          msg: [reason || "Validation failed!", MESSAGE.ERROR],
        });
      }
    } catch (error) {
      this.setState({
        msg: [error.toString(), MESSAGE.ERROR],
      });
    }
    this.setState({ isProcessing: false });
  }

  handleSaveData() {
    const { isValidated, notesInput } = this.state;
    const { handleSave } = this.props;
    if (isValidated && handleSave) {
      handleSave(notesInput);
    }
  }

  render() {
    const { handleClose, type } = this.props;

    const { inputValue, isValidated, msg, isProcessing, isConfigDiff } =
      this.state;

    let title = "";
    if (type === CUSTOM_TYPE.FIRST_LOOK) {
      title = "Preview and Save Custom First Look";
    } else if (type === CUSTOM_TYPE.UPR) {
      title = "Preview and Save Custom UPR";
    } else if (type === CUSTOM_TYPE.UPR_SEGMENTATION) {
      title = "Preview and Save UPR Segmentation";
    } else if (type === CUSTOM_TYPE.CST_CONFIG) {
      title = "Preview and Save CST Config";
    }

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        width="50%"
        title={title}
        customOverlayStyle={{ zIndex: 100 }}
      >
        <label
          className={`text-xs ${
            isConfigDiff ? "font-semibold text-blue-600" : "text-gray-800"
          } `}
        >
          Note
        </label>
        {!isConfigDiff ? (
          <NotesInformation notes={null} />
        ) : (
          <NotesEditor onChanged={this.handleNotesChanged} />
        )}
        <label className="text-xs text-gray-800">Config</label>
        <div
          style={{ height: _.isNil(this.props.children) ? "520px" : "450px" }}
        >
          <div className="border rounded flex h-full overflow-y-auto border-gray-400 bg-gray-100 p-2 text-sm">
            <pre>{inputValue}</pre>
          </div>
        </div>

        <div className="mb-4">{this.props.children}</div>

        <ModalFooter
          msg={msg}
          redo={true}
          isLoading={isProcessing}
          onCancel={handleClose}
          confirmText="Save"
          onConfirm={this.handleSaveData}
          disableConfirm={!isValidated}
        >
          <button
            type="button"
            className={buttonModalConfirmClass}
            onClick={this.handleValidate}
          >
            Validate
          </button>
        </ModalFooter>
      </ModalWrapper>
    );
  }
}

export default PreviewValidateModal;
